import React from 'react'
import './style.css'

const ProjectCard = ({ img, title, des, link, ...otherprops }) => {
    return (
        <div className="m-4 rounded bg-gray-800 cursor-pointer projectcard"
            {...otherprops}
            onClick={() => window.open(link, title)}
        >
            <img src={img} alt={title} className='pb-2' style={{ maxHeight: '150px', margin: 'auto' }} />
            <div className="px-1">
                <h3 className='text-center font-sans font-semibold'>{title}</h3>
                <p className="font-sans text-center font-normal">{des}</p>
            </div>
        </div>
    )
}

export default ProjectCard
